(function ($) { 
    
    Drupal.behaviors.museumVersionUpdate = function (){

        //reload start page if forbidden page loaded
        var currentPageUrl = window.location.href;
        if(currentPageUrl.indexOf("user") >= 0 || currentPageUrl.indexOf("apply") >= 0 || currentPageUrl.indexOf("password") >= 0){
            window.location.href = 'https://www.swatch-art-peace-hotel.com/museum-version';
        }

        //change logo image link
        $(".logoImage").find("a").attr("href", "/museum-version");

        //disable links
        Drupal.behaviors.disableLinksForMuseumVersion();
        setTimeout(Drupal.behaviors.disableLinksForMuseumVersion,1000);
        setTimeout(Drupal.behaviors.disableLinksForMuseumVersion,2500);
        setTimeout(Drupal.behaviors.disableLinksForMuseumVersion,5000);
        setTimeout(Drupal.behaviors.disableLinksForMuseumVersion,10000);
    };  

    Drupal.behaviors.disableLinksForMuseumVersion = function (){

        $("a").each(function(){
            $(this).removeClass("disableOnMuseumVersion");
            if($(this).attr("href")){
                if($(this).attr("href").indexOf("http") >= 0){
                    //set "disable" class to every external link
                    $(this).addClass("disableOnMuseumVersion");
                }
                else if($(this).attr("href") == "/" || $(this).attr("href") == "/home"){
                    //change home links to museum-version
                    $(this).attr("href", "/museum-version");
                }
                else if($(this).attr("href").indexOf("apply") >= 0 || $(this).attr("href").indexOf("user") >= 0 || $(this).attr("href").indexOf("password") >= 0){
                    //hide user account links
                    $(this).removeClass("hideOnMuseumVersion");
                    $(this).addClass("hideOnMuseumVersion");
                    if($(this).parent("p").length > 0){
                        $(this).parent("p").removeClass("hideOnMuseumVersion");
                        $(this).parent("p").addClass("hideOnMuseumVersion");
                    }
                }
            }
        });        
    };
    
})(jQuery);